const steps = [
    {
        target: '#usage-date-range',
        title: "Date Range Selector",
        content: (
            <div>
                Select a custom date range or use the quick select buttons to filter usage data for a specific time period.
            </div>
        ),
        disableBeacon: true,
    },

    {
        target: '#usage-quick-select',
        title: "Quick Select Buttons",
        content: (
            <div>
                Quickly jump to common time periods like 1 Day, 7 Days, 1 Month, etc. The selected period is highlighted in blue.
            </div>
        ),
    },

    {
        target: '#usage-statistics-cards',
        title: "Operation Statistics",
        content: (
            <div>
                View the total count of each operation type (Create, Update, Delete) for the selected period.
            </div>
        ),
    },

    {
        target: '#usage-resource-breakdown',
        title: "Resource-wise Usage Breakdown",
        content: (
            <div>
                This table breaks down usage by resource, showing how many create, update, and delete operations were performed on each resource.
            </div>
        ),
    },

    {
        target: '#usage-by-resource-chart',
        title: "Usage by Resource Chart",
        content: (
            <div>
                Visualize resource usage with bar or line charts. Toggle between chart types using the buttons to see which resources are being used most frequently.
            </div>
        ),
    },

    {
        target: '#usage-trends-chart',
        title: "Operation Trends Over Time",
        content: (
            <div>
                Track how your operations trend over the selected date range. Switch between line and bar charts to analyze patterns in your usage.
            </div>
        ),
    },
];

export default steps;
